
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.985 1.6h-11.7v3.7h11.7V1.6z","fill":"#F9A91E"}}),_c('path',{attrs:{"d":"M25.885 7.6v-.4h-11.6v11.6c0 .2-.1.4-.3.6-1.3 1-2.6 2-3.8 3-3.2 2.5-2.9 7.4 1 9.5 2.1 1.1 4.2.8 6.1-.6 2.8-2.1 5.5-4.2 8.3-6.3.2-.2.3-.3.3-.6V7.6zm-12.9 23.2c-1.7-.3-2.7-1.4-3.2-3-.4-1.4-.1-2.7 1-3.9 2 2 3.9 3.9 5.8 5.9-1 .9-2.2 1.3-3.6 1zm11.3-7c0 .1-.1.2-.2.3-.8.6-1.6 1.2-2.5 1.9-.5-1-.6-2.1-.2-3.2.5-1.4 1.5-2.2 2.9-2.7v3.7zm-.3-5.2c-3.6.9-5.4 4.7-3.8 8.1 0 .1.1.2.1.3l-2.4 1.8-5.9-5.9c.5-.4 1.1-.8 1.6-1.3.6-.5 1.3-1 1.9-1.5.2-.1.3-.3.3-.5v-6.1-3.3-1.4h8.4v9.3c.1.3.1.4-.2.5z","fill":"#36C0B6"}})])
          )
        }
      }
    